import { Text, View } from "@react-pdf/renderer";
import { payments } from "lobbie";
import { BROWSER_TIME_ZONE } from "src/constants";
import { ESubscriptionRecurrenceType, recurrenceFreqToUnit } from "src/types/global_enums";
import { daysjsFromUnix } from "src/utils";
import styles, { pdfColors } from "../base/styles";

interface IProps {
    charge: payments.print.IInvoiceLineItem;
    taxRate?: number;
    applyTax: boolean;
}

const InvoiceLineItem: React.FC<IProps> = ({ charge, taxRate, applyTax }) => {
    const isSubscription = !!charge.serviceRecurrenceType;
    let subscriptionType = "";

    const frequencyUnit = charge.recurrenceFrequencyUnit
        ? recurrenceFreqToUnit.get(charge.recurrenceFrequencyUnit)
        : "";

    if (isSubscription) {
        if (charge.serviceRecurrenceType === ESubscriptionRecurrenceType.FINITE) {
            subscriptionType = `${charge.occurrences} Installments`;
        } else {
            subscriptionType = `Ongoing Subscription`;
        }
    }

    let cost = charge.amountCents / 100;
    let formattedCost;
    let formattedTotalCost;

    if (charge.discountPercent) {
        cost = cost * (1 - charge.discountPercent / 100);
    }

    if (charge.priceAdjustmentCents) {
        cost += charge.priceAdjustmentCents / 100;
    }

    formattedCost = cost.toLocaleString(undefined, {
        minimumFractionDigits: 2,
    });
    formattedTotalCost = (charge.quantity * cost).toLocaleString(undefined, {
        minimumFractionDigits: 2,
    });

    let startDate = "";
    if (isSubscription && charge.startDateUnix) {
        startDate = daysjsFromUnix(charge.startDateUnix, BROWSER_TIME_ZONE).format(
            "MM / DD / YYYY",
        );
    }

    return (
        <View
            style={[
                styles.row,
                styles.w100,
                styles.pb8,
                styles.pt8,
                styles.justBetween,
                { borderBottom: "0.5px", borderBottomColor: pdfColors.Gray20 },
            ]}
        >
            <View style={[styles.row, { gap: "12px" }]}>
                <View style={[{ width: "150px", alignItems: "flex-start" }]}>
                    <Text style={[styles.textBlack]}>{charge.description}</Text>
                    {isSubscription && (
                        <Text
                            style={[styles.textGray65]}
                        >{`${subscriptionType} - $${formattedCost}/${frequencyUnit}`}</Text>
                    )}
                </View>
                <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                    <Text style={[styles.textBlack]}>{charge.code}</Text>
                </View>
                <View style={[{ width: "60px", alignItems: "flex-start" }]}>
                    <Text style={[styles.textBlack]}>{startDate}</Text>
                </View>
            </View>

            <View style={[styles.row, styles.textBlack, { gap: "12px" }]}>
                <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                    <Text> {isSubscription ? "" : charge.quantity}</Text>
                </View>
                <View style={[{ width: "50px", alignItems: "flex-end" }]}>
                    <Text>{isSubscription ? "" : `$ ${formattedCost}`}</Text>
                </View>
                {applyTax && (
                    <View style={[{ width: "30px", alignItems: "flex-end" }]}>
                        <Text>{taxRate && !isSubscription ? `${taxRate} %` : ""}</Text>
                    </View>
                )}
                <View style={[{ width: "55px", alignItems: "flex-end" }]}>
                    <Text>{isSubscription ? "" : `$ ${formattedTotalCost}`}</Text>
                </View>
            </View>
        </View>
    );
};

export default InvoiceLineItem;
